module.exports = __webpack_public_path__ + "Flag-20.fd893495e6747f8f586e62824f6d6869.svg";